import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../Color.js";
import { isSymbol3D as t, isSymbol2D as r } from "../../symbols.js";
import { forEach as o } from "../../core/asyncUtils.js";
import n from "../../core/has.js";
import { isSome as l, isNone as i, unwrap as s, get as c } from "../../core/maybe.js";
import { px2pt as u } from "../../core/screenUtils.js";
import { O as a } from "../../chunks/vec3f64.js";
import { effectFunctionsFromJSON as f } from "../../layers/effects/jsonUtils.js";
import { getStroke as m } from "./gfxUtils.js";
import y from "./Symbol3DMaterial.js";
var p = /\/resource\/(.*?)\.svg$/,
    h = new e("white");

function b(e) {
  var t = e.symbolLayers && e.symbolLayers.length;
  if (!t) return;
  var r = e.symbolLayers.getItemAt(t - 1);
  return "outline" in r ? c(r, "outline", "size") : void 0;
}

function w(e) {
  if (!e) return 0;

  if (t(e)) {
    var _t = b(e);

    return l(_t) ? _t : 0;
  }

  var r = m(e);
  return r && u(r.width) || 0;
}

function d(e) {
  if (i(e) || !("symbolLayers" in e) || i(e.symbolLayers)) return !1;

  switch (e.type) {
    case "point-3d":
      return e.symbolLayers.some(function (e) {
        return "object" === e.type;
      });

    case "line-3d":
      return e.symbolLayers.some(function (e) {
        return "path" === e.type;
      });

    case "polygon-3d":
      return e.symbolLayers.some(function (e) {
        return "object" === e.type || "extrude" === e.type;
      });

    default:
      return !1;
  }
}

function g(e, t) {
  var r = t.resource.href;
  return !n("esri-canvas-svg-support") && e.styleOrigin && p.test(r) ? r.replace(p, "/resource/png/$1.png") : r;
}

function j(o, n) {
  if (!o) return null;
  var l = null;
  return t(o) ? l = k(o) : r(o) && (l = o.color ? new e(o.color) : null), l ? L(l, n) : null;
}

function k(t) {
  var r = t.symbolLayers;
  if (!r) return null;
  var o = null;
  return r.forEach(function (e) {
    "object" === e.type && null != e.resource.href || (o = "water" === e.type ? s(e.color) : l(e.material) ? s(e.material.color) : null);
  }), o ? new e(o) : null;
}

function L(t, r) {
  if (null == r) return t;
  var o = t.toRgba();
  return o[3] = o[3] * r, new e(o);
}

function z(e, t, r) {
  var o = e.symbolLayers;
  if (!o) return;

  var n = function n(e) {
    var o = l(e) ? e : null;
    return L(t = t || o || null != r && h, r);
  };

  o.forEach(function (e) {
    if ("object" !== e.type || null == e.resource.href || t) if ("water" === e.type) e.color = n(e.color);else {
      var _t2 = l(e.material) ? e.material.color : null,
          _o = n(_t2);

      i(e.material) ? e.material = new y({
        color: _o
      }) : e.material.color = _o, null != r && "outline" in e && l(e.outline) && l(e.outline.color) && (e.outline.color = L(e.outline.color, r));
    }
  });
}

function v(e, t, r) {
  (t = t || e.color) && (e.color = L(t, r)), null != r && "outline" in e && e.outline && e.outline.color && (e.outline.color = L(e.outline.color, r));
}

function x(o, n, l) {
  o && (n || null != l) && (n && (n = new e(n)), t(o) ? z(o, n, l) : r(o) && v(o, n, l));
}

function S(_x, _x2) {
  return _S.apply(this, arguments);
}

function _S() {
  _S = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
    var r;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            r = e.symbolLayers;
            _context2.t0 = r;

            if (!_context2.t0) {
              _context2.next = 5;
              break;
            }

            _context2.next = 5;
            return o(r, /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", U(e, t));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x10) {
                return _ref.apply(this, arguments);
              };
            }());

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _S.apply(this, arguments);
}

function U(_x3, _x4) {
  return _U.apply(this, arguments);
}

function _U() {
  _U = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = e.type;
            _context3.next = _context3.t0 === "extrude" ? 3 : _context3.t0 === "icon" ? 5 : _context3.t0 === "line" ? 5 : _context3.t0 === "text" ? 5 : _context3.t0 === "path" ? 7 : _context3.t0 === "object" ? 9 : 11;
            break;

          case 3:
            R(e, t);
            return _context3.abrupt("break", 11);

          case 5:
            O(e, t);
            return _context3.abrupt("break", 11);

          case 7:
            A(e, t);
            return _context3.abrupt("break", 11);

          case 9:
            _context3.next = 11;
            return $(e, t);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _U.apply(this, arguments);
}

function O(e, t) {
  var r = E(t);
  l(r) && (e.size = r);
}

function E(e) {
  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t3 = _step.value;
      if ("number" == typeof _t3) return _t3;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}

function R(e, t) {
  e.size = "number" == typeof t[2] ? t[2] : 0;
}

function $(_x5, _x6) {
  return _$.apply(this, arguments);
}

function _$() {
  _$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
    var _yield$D, r, o, n;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return D(e);

          case 2:
            _yield$D = _context4.sent;
            r = _yield$D.resourceSize;
            o = _yield$D.symbolSize;
            n = C(t, r, o);
            e.width = I(t[0], o[0], r[0], n), e.depth = I(t[1], o[1], r[1], n), e.height = I(t[2], o[2], r[2], n);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _$.apply(this, arguments);
}

function A(e, t) {
  var r = C(t, a, [e.width, void 0, e.height]);
  e.width = I(t[0], e.width, 1, r), e.height = I(t[2], e.height, 1, r);
}

function C(e, t, r) {
  for (var _o2 = 0; _o2 < 3; _o2++) {
    var _n = e[_o2];

    switch (_n) {
      case "symbol-value":
        return null != r[_o2] ? r[_o2] / t[_o2] : 1;

      case "proportional":
        break;

      default:
        if (_n && t[_o2]) return _n / t[_o2];
    }
  }

  return 1;
}

function D(_x7) {
  return _D.apply(this, arguments);
}

function _D() {
  _D = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
    var t, r, o, n, l, i, s, _c, _c2;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return import("./symbolLayerUtils.js");

          case 2:
            t = _context5.sent;
            _context5.next = 5;
            return t.computeObjectLayerResourceSize(e, 10);

          case 5:
            r = _context5.sent;
            o = e.width;
            n = e.height;
            l = e.depth;
            i = [o, l, n];
            s = 1;
            _c = 0;

          case 12:
            if (!(_c < 3)) {
              _context5.next = 19;
              break;
            }

            if (!(null != i[_c])) {
              _context5.next = 16;
              break;
            }

            s = i[_c] / r[_c];
            return _context5.abrupt("break", 19);

          case 16:
            _c++;
            _context5.next = 12;
            break;

          case 19:
            for (_c2 = 0; _c2 < 3; _c2++) {
              null == i[_c2] && (i[_c2] = r[_c2] * s);
            }

            return _context5.abrupt("return", {
              resourceSize: r,
              symbolSize: i
            });

          case 21:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _D.apply(this, arguments);
}

function I(e, t, r, o) {
  switch (e) {
    case "proportional":
      return r * o;

    case "symbol-value":
      return null != t ? t : r;

    default:
      return e;
  }
}

function J(e, t) {
  var r = E(t);
  if (!i(r)) switch (e.type) {
    case "simple-marker":
      e.size = r;
      break;

    case "picture-marker":
      {
        var _t4 = e.width / e.height;

        _t4 > 1 ? (e.width = r, e.height = r * _t4) : (e.width = r * _t4, e.height = r);
        break;
      }

    case "simple-line":
      e.width = r;
      break;

    case "text":
      e.font.size = r;
  }
}

function M(_x8, _x9) {
  return _M.apply(this, arguments);
}

function _M() {
  _M = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, o) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(e && o)) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return", t(e) ? S(e, o) : void (r(e) && J(e, o)));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _M.apply(this, arguments);
}

function N(e, o, n) {
  if (e && null != o) if (t(e)) {
    var _t5 = e.symbolLayers;
    _t5 && _t5.forEach(function (e) {
      if (e && "object" === e.type) switch (n) {
        case "tilt":
          e.tilt = o;
          break;

        case "roll":
          e.roll = o;
          break;

        default:
          e.heading = o;
      }
    });
  } else r(e) && ("simple-marker" !== e.type && "picture-marker" !== e.type && "text" !== e.type || (e.angle = o));
}

function q(e) {
  if (!e) return null;
  var t = e.effects.filter(function (e) {
    return "bloom" !== e.type;
  }).map(function (e) {
    return e.toJSON();
  });
  return f(t);
}

export { x as applyColorToSymbol, L as applyOpacityToColor, N as applyRotationToSymbol, M as applySizesToSymbol, q as getCSSFilterFromEffectList, j as getColorFromSymbol, g as getIconHref, w as getSymbolOutlineSize, d as isVolumetricSymbol };